import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/500.css';
import '@fontsource/montserrat/600.css';
import '@fontsource/montserrat/700.css';
import '@fontsource/lato/400.css';
import '@fontsource/lato/700.css';
import 'lang/config.js';
import 'styles/tailwind.scss';

import wrapWithProvider from './wrap-with-provider';
export const wrapRootElement = wrapWithProvider;

export const onServiceWorkerUpdateReady = () => {
	console.info('Aplikacja została zaktualizowana.');
};

export const onRouteUpdate = () => {
	// if (typeof window !== 'undefined' && process.env.NODE_ENV === 'production' && window?.navigator?.serviceWorker) {
	// 	window.navigator.serviceWorker.register('/sw.js').then(reg => {
	// 		reg.update();
	// 	});
	// }
};

export const onClientEntry = () => {
	console.info('onClientEntry');
};
